import React, { useState } from 'react';
import { Box, Typography, TextField, IconButton } from '@mui/material';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import ClearIcon from '@mui/icons-material/Clear';
import { datePickerStyles } from './DatePicker.styles';

const DatePicker = ({ value, onChange, title, icon, placeholder = 'Select date', open: controlledOpen, onOpenChange }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = (newOpen) => {
    if (controlledOpen === undefined) {
      setInternalOpen(newOpen);
    } else if (onOpenChange) {
      onOpenChange(newOpen);
    }
  };

  const formattedDate = value ? format(value, 'dd/MM/yyyy') : '';

  const handleClear = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onChange(null);
    setOpen(false)
  };

  const handleContainerClick = () => {
   setOpen(true);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={datePickerStyles.container}
        onClick={handleContainerClick}
      >
        <Box sx={datePickerStyles.inputContainer}>
          <Box sx={datePickerStyles.iconContainer}>{icon}</Box>
          <Box sx={datePickerStyles.textContainer}>
            <Typography sx={datePickerStyles.title}>{title}</Typography>
            <Typography
              sx={datePickerStyles.subtitle}
              fontWeight={value ? 500 : 400}
            >
              {formattedDate || placeholder}
            </Typography>
          </Box>
          {value && (
              <IconButton sx={datePickerStyles.iconContainer} onClick={handleClear}>
                <ClearIcon/>
              </IconButton>
           
          )}
        </Box>
      
          <MuiDatePicker
            value={value}
            onChange={(newValue) => {
              onChange(newValue);
              // Close the picker immediately after selection
              setTimeout(() => {
                setOpen(false);
              }, 0);
            }}
            onClose={() => setOpen(false)}
            closeOnSelect={true}
            enableAccessibleFieldDOMStructure={false}
            slots={{
              textField: TextField,
            }}
            open={open}
            slotProps={{
            textField: {
              sx: datePickerStyles.hiddenInput,
            },
            popper: {
              sx: datePickerStyles.datePickerPopper,
            },
            layout: {
              sx: {
                backgroundColor: '#fff',
                color: '#252629',
              },
            },
            actionBar: {
              actions: [],
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DatePicker;

